import React from "react";
import { ArrowRight, Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function JetztKontaktAufnehmen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}